<template>
  <div v-if="report.companyoverview.creditreport">
    <report-panel :report="report" :anchor="''">
      <div slot="title">County Court Judgements</div>
      <div slot="body">
        <div
          v-if="report.companyoverview.creditreport.countycourtjudgments.length === 0"
          class="well well-sm well-positive"
        >
          <table class="table-condensed" id="credit-ccj-header-table">
            <tbody>
              <tr>
                <td width="50" style="text-align: center">
                  <i class="fas fa-check"></i>
                </td>
                <td>
                  <h4>No County Court Judgements found</h4>
                  <p>
                    Using the search
                    <strong>{{ report.companyoverview.company_name }}</strong>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="report.companyoverview.creditreport.countycourtjudgments.length > 0">
          <div class="well well-sm well-negative">
            <table class="table-condensed" id="credit-ccj-header-table">
              <tbody>
                <tr>
                  <td width="50" style="text-align: center">
                    <i class="fas fa-exclamation"></i>
                  </td>
                  <td>
                    <h4>Possible County Court Judgements found</h4>
                    <p>
                      Using the search <strong>{{ report.companyoverview.company_name }}</strong
                      >. Where <em>"possible"</em> matches are indicated please check the address
                      details below to ensure any CCJs listed match those of
                      {{ report.companyoverview.company_name }}.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-responsive">
            <table class="table table-striped table-condensed" id="credit-ccj-detail-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Case Number</th>
                  <th>Business Address</th>
                  <th>Court</th>
                  <th class="text-right">Amount</th>
                  <th>Status</th>
                  <th>Satisfied Date</th>
                  <th>Match Type</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="ccj in report.companyoverview.creditreport.countycourtjudgments"
                  :key="ccj.id"
                >
                  <td>{{ formatDate(ccj.date) }}</td>
                  <td>{{ ccj.case_number }}</td>
                  <td width="15%">{{ ccj.address }}</td>
                  <td>{{ ccj.court }}</td>
                  <td class="text-right">{{ formatCurrency(ccj.amount, '£') }}</td>
                  <td>{{ ccj.status }}</td>
                  <td>{{ formatDate(ccj.satisfied_date) }}</td>
                  <td>
                    <span class="label label-positive" :class="getClass(ccj.match_type)">{{
                      ccj.match_type
                    }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </report-panel>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import ReportPanel from '@/components/reports/components/ReportPanel';

export default {
  components: {
    ReportPanel,
  },
  mixins: [toolsMixin],
  props: ['report'],
  methods: {
    getClass(matchType) {
      if (matchType === 'exact') {
        return 'label-negative';
      }
      return 'label-amber';
    },
  },
};
</script>
